import Box from "@mui/material/Box";
import React, { FunctionComponent, PropsWithChildren } from "react";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";

export interface PaneFooterProps extends PropsWithChildren {
}

export const PaneFooter: FunctionComponent<PaneFooterProps> = (props) => {
	const { children } = props;

	return (
		<Box
			borderTop={STANDARD_BORDER_STYLE}
			flexShrink={0}
			p={3}
		>
			{children}
		</Box>
	);
};

export default PaneFooter;